import React from "react";

import { Switch, Route } from "react-router-dom";

import ReportsPage from "./ReportsPage";

const ReportsRouter = () => (
  <Switch>
    <Route path="/reports/viewer/:reportName">
      <ReportsPage />
    </Route>
  </Switch>
);

export default ReportsRouter;
